import { useEffect, useState } from "react";
import { onKeyboardToggle } from "../lib/platform";

/**
 * Whether the native keyboard is currently open. Always false on web.
 */
export const useKeyboardVisible = (): boolean => {
  const [visible, setVisible] = useState(false);
  useEffect(() => onKeyboardToggle(setVisible), []);
  return visible;
};
